import { Injectable } from '@angular/core';
import { MChapterData } from '../models/chapter-data.model';
import { MModuleEvaluation } from '../models/module-evaluation.model';
import { MEvaluation } from '../models/evaluation.model';

@Injectable({
  providedIn: 'root'
})
export class EvaluationDataIdService {

  constructor() { }

  private versionId: number = null;
  private processId: number = 0;
  private evaluationInfo: MModuleEvaluation = null;
  private evaluation: MEvaluation = null;

  public setVersionId(id: number){
    this.versionId = id;
  }

  public getVersionId(): number{
    return this.versionId;
  }

  public setProcessId(id: number){
    this.processId = id;
  } 

  public getProcessId(): number {
    return this.processId;
  }

  public setEvaluationInfo(eva: MModuleEvaluation){
    this.evaluationInfo = eva;
  }

  public getEvaluationInfo(): MModuleEvaluation{
    return this.evaluationInfo;
  }

  public setEvaluation(eva: MEvaluation){
    this.evaluation = eva;
  }

  public getEvaluation(): MEvaluation{
    return this.evaluation;
  }

  public reset(){
    this.evaluation = null;
    this.evaluationInfo = null;
    this.versionId = null;
    this.processId = 0;
  }

}
